
export const TAB_TEXT = [
  "Select the Controller Model",
  "Select Type",
  "Edit and Save",
];

export const A_P_TAB_TEXT = [
  "Select Device",
  "Select Type",
  "Edit and Save",
];

export const WIZARD_LIST = [
  {
    id: "531465464",
    name: "ICON-Pro",
  },
  {
    id: "0031456465464",
    name: "ICON",
  },
  {
    id: "0031403545464",
    name: "AIR-CR",
  },
];

export const ADD_ACU_RESPONSE_TYPES = {
  200: {
    title: "Successful!",
    subTitle: ["The controller has been found!"],
    description:
      "you can change the controller name now and provide a description, or you can do it later.",
  },
  42: {
    title: "No controller with this serial number was found.",
    subTitle: [
      "The search may have been performed before the unit had time to boot up.",
      "Make sure the serial number is entered correctly.",
      "Make sure the controller is connected to a power source and has access to the Internet.",
    ],
    description:
      "The controller will be added to the account and will be available as soon as it is online,",
  },
  44: {
    title: "Outdated firmware version!",
    subTitle: [
      `The firmware version of the controller is out of date and will not allow it to be added by serial number.
                Update the firmware version and try adding the controller again.`,
    ],
  },
  43: {
    title: "The serial number belongs to a different controller model.",
    subTitle: [
      "Make sure you have selected the correct model and search again.",
    ],
  },
  45: {
    title: "Something went wrong!",
    subTitle: [
      `The controller is online but has stopped responding while requesting
                registration data for an account.
                This may cause an error when attempting to re-request the account registration data.
                Perform a full reset of the device and try again.`,
    ],
  },
  41: {
    title: "The controller is used by another account!",
    subTitle: [
      `The controller cannot be added because it belongs to another account.`,
    ],
  },
  40: {
    title: "The controller has already been added to the current account!",
    subTitle: [`Make sure that the serial number has been entered correctly.`],
  },
};

export const ADD_ACU_SUCCESS = {
  200: {
    title: "Successful!",
    subTitle: [
      "The virtual controller has been created and is ready to be added!",
    ],
    description: `You can change the controller name now and provide a description, or you can do le later.`,
  },
};

export const A_P_TEMPLES = {
  door: [
    { label: "One Reader", value: "One_Reader" },
    { label: "Tow Readers", value: "Tow_Readers" },
  ],
  turnstile: [
    { label: "One Side - One Reader", value: "One_Side_One_Reader" },
    { label: "Tow Sides - Tow Readers", value: "Tow_Sides_Tow_Readers" },
  ],
  carBarrier: [
    { label: "Car Barrier - One Reader", value: "Car_Barrier_One_Reader" },
    { label: "Car Barriers - Tow Readers", value: "Car_Barriers_Tow_Readers" },
  ],
}


export const ACCESS_POINT_DATA = [
  {
    id: "001",
    type: "door",
    img: "https://developp.exportfeed.com/wp-content/uploads/2023/09/64508202-test-written-by-hand-hand-writing-on-transparent-board-photo.jpg",
    name: "Door"
  },
  {
    id: "002",
    type: "turnstile",
    img: "https://developp.exportfeed.com/wp-content/uploads/2023/09/64508202-test-written-by-hand-hand-writing-on-transparent-board-photo.jpg",
    name: "Turnstile"
  },
  {
    id: "003",
    type: "carBarrier",
    img: "https://developp.exportfeed.com/wp-content/uploads/2023/09/64508202-test-written-by-hand-hand-writing-on-transparent-board-photo.jpg",
    name: "Car Barrier"
  },

]

export const A_P_SELECTED_ITEM_TYPES = {
  door: [{ label: "RFID", value: "RFID" }, { label: "Door Sensor", value: "DoorSensor" }, { label: "Exit Button", value: "ExitButton" }, { label: "Lock", value: "Lock" }],
  turnstile: [{ label: "RFID", value: "RFID" }, { label: "Door Sensor", value: "DoorSensor" }, { label: "Exit Button", value: "ExitButton" }, { label: "Lock", value: "Lock" }],
  carBarrier: [{ label: "RFID", value: "RFID" }, { label: "Door Sensor", value: "DoorSensor" }, { label: "Exit Button", value: "ExitButton" }, { label: "Lock", value: "Lock" }],
}


export const RESOURCES = {
  Door_sensor: { label: "Door Sensor", value: "DoorSensor" },
  Exit_button: { label: "Exit Button", value: "ExitButton" },
  Fire_Alarm_in: { label: "Fire Alarm in", value: "FireAlarmIn" },
  Entry_button: { label: "Entry Button", value: "EntryButton" },
  Entry_relay: { label: "Entry Relay", value: "EntryRelay" },
  Exit_relay: { label: "Exit Relay", value: "ExitRelay" },
  Pass_control: { label: "Pass Control", value: "PassControl" },
  Open_button: { label: "Open Button", value: "OpenButton" },
  Open_relay: { label: "Open Relay", value: "OpenRelay" },
  Lock: { label: "Lock", value: "Lock" },
  Alarm_out: { label: "Alarm Out", value: "AlarmOut" },
  Block: { label: "Block", value: "Block" },
  Block_Turnstile: { label: "Block Turnstile", value: "BlockTurnstile" },
  Emergency_open: { label: "Emergency Open", value: "EmergencyOpen" },
  Loop_sensor: { label: "Loop Sensor", value: "LoopSensor" },
  "0": { label: "RFID", value: "RFID" },
  "1": { label: "KEYPAD", value: "KEYPAD" },
  "2": { label: "FINGER", value: "FINGER" },
  "3": { label: "FACE", value: "FACE" },
}

export const TEMPLATE_INFO = {
  reader: {
    "1": { id: 1, label: "Wiegand port 1" },
    "2": { id: 2, label: "Wiegand port 2" },
    direction: {
      '0': "ENTRY",
      '1': "EXIT",
    }
  },
  input: {
    "0": {
      "1": { id: 1, label: "REX 1" },
      "2": { id: 2, label: "DOOR 1" },
      "3": { id: 3, label: "IN 1" },
      "4": { id: 4, label: "IN 2" },
    }
  },
  output: {
    "0": {
      "1": { id: "1", label: "RELAY 1" },
      "2": { id: "2", label: "AUX GND" }
    },
    relay_mode: {
      "0": { id: "1", label: "Trigger" },
      "1": { id: "2", label: "Impulse" }
    }
  }

}